export default __webpack_public_path__ + "static/media/marknellemann.0708b7de.jpg";